import { Injectable, NgZone, OnDestroy } from '@angular/core';
import { AuthService } from './auth.service';

const STORAGE_KEY = 'lastActivity';
const IDLE_MS = 60 * 60 * 1000; // 1 hour
const CHECK_INTERVAL_MS = 60 * 1000; // check every minute
const ACTIVITY_EVENTS = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'scroll', 'click'] as const;

@Injectable({ providedIn: 'root' })
export class IdleService implements OnDestroy {
  private checkTimer?: ReturnType<typeof setInterval>;
  private readonly handler = () => this.recordActivity();

  constructor(
    private auth: AuthService,
    private zone: NgZone,
  ) {}

  start(): void {
    this.recordActivity();
    ACTIVITY_EVENTS.forEach((e) => window.addEventListener(e, this.handler, { passive: true }));
    // Run the timer outside Angular zone to avoid unnecessary change detection cycles
    this.zone.runOutsideAngular(() => {
      this.checkTimer = setInterval(() => this.checkIdle(), CHECK_INTERVAL_MS);
    });
  }

  recordActivity(): void {
    localStorage.setItem(STORAGE_KEY, Date.now().toString());
  }

  isIdleTooLong(): boolean {
    const last = parseInt(localStorage.getItem(STORAGE_KEY) ?? '0', 10);
    return last > 0 && Date.now() - last > IDLE_MS;
  }

  private checkIdle(): void {
    if (!this.auth.isLoggedIn()) return;
    if (this.isIdleTooLong()) {
      this.zone.run(() => this.auth.logout());
    }
  }

  ngOnDestroy(): void {
    if (this.checkTimer !== undefined) clearInterval(this.checkTimer);
    ACTIVITY_EVENTS.forEach((e) => window.removeEventListener(e, this.handler));
  }
}
